// Edit contact details, map location and indicative fares here.
export const SITE_URL = "https://miralgroup.net";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1791491864333-d7cb88cab40b?crop=entropy&cs=srgb&fm=jpg&q=85",
  m3: "https://images.unsplash.com/photo-1791491864333-d7cb88cab40b?crop=entropy&cs=srgb&fm=jpg&q=85",
  my: "https://images.unsplash.com/photo-1600661288038-cb63953bfc9f?crop=entropy&cs=srgb&fm=jpg&q=85",
  front: "https://images.unsplash.com/photo-1576221162298-3d9f04e9f661?crop=entropy&cs=srgb&fm=jpg&q=85",
  wheel: "https://images.unsplash.com/photo-1791491863686-d265d2e81020?crop=entropy&cs=srgb&fm=jpg&q=85",
  brussels: "https://images.unsplash.com/photo-1623741099118-e3095a66784a?crop=entropy&cs=srgb&fm=jpg&q=85",
  chauffeur: "https://images.unsplash.com/photo-1607642857266-88f5f03e66c6?crop=entropy&cs=srgb&fm=jpg&q=85",
  standing: "https://images.unsplash.com/photo-1627285886624-5cd637dafb50?crop=entropy&cs=srgb&fm=jpg&q=85"
};

export const CONTACT = {
  phone: "+32 2 000 0000",
  phoneHref: "tel:+3220000000",
  whatsapp: "3220000000",
  email: "contact@miralgroup.net",
  address: "Toison, 2100 Antwerp",
  hq: [51.2183, 4.4626],
  airport: [50.9014, 4.4844],
  airportLabel: "BRU"
};

export const FARES = {
  routes: [
    { id: "bru", price3: 55, priceY: 65 },
    { id: "crl", price3: 95, priceY: 105 },
    { id: "hourly", price3: 65, priceY: 75, hourly: true }
  ]
};

export const SERVICE_SLUGS = ["airport", "eu", "corporate", "events", "other"];

export const BOOKING_DEPOSIT = { lookupKey: "booking_deposit", amountLabel: "€20" };

export const EASE = [0.22, 1, 0.36, 1];
